export const themeOptions = {
  palette: {
    type: 'dark',
    primary: {
      main: '#354775',
    },
    secondary: {
      main: '#f50057',
    },
    error: {
      main: '#f44336',
    },
    warning: {
      main: '#ff9800',
    },
    info: {
      main: '#2196f3',
    },
    success: {
      main: '#4caf50',
    },
    btn_primary: {
      main: '#354775',
    },
    btn_secondary: {
      main: '#f50057',
    },
    btn_error: {
      main: '#f44336',
    },
    btn_warning: {
      main: '#ff9800',
    },
    btn_info: {
      main: '#2196f3',
    },
    btn_success: {
      main: '#4caf50',
    },
    header_background_main: {
      main: 'rgb(53, 71, 117)',
    },
    plate_background: {
      main: 'rgb(235, 237, 248)',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
};
